import { CreditCardStyled } from '@vgrubs/components';
import styled from 'styled-components';

export const UserPendingEarningsCreditCardStyled = styled(CreditCardStyled)`
  background: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.blue};
`;

export const UserCardsZoom = styled.div`
  @media (max-width: 500px) {
    zoom: 0.8;
  }
  @media (max-width: 380px) {
    zoom: 0.7;
  }
`;
